import { useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { VLInput } from "views/uikit/FormFields/VLInput/VLInput";
import styles from "./style.module.scss";
import classNames from "classnames";

interface VLInputWithLabelProps {
  id: string;
  label: string;
  value?: string;
  type?: string;
  error?: string | null;
  showPasswordToggle?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const VLInputWithLabel = ({
  id,
  label,
  value = "",
  type = "text",
  error = null,
  showPasswordToggle = false,
  onChange,
}: VLInputWithLabelProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const inputType = showPasswordToggle
    ? showPassword
      ? "text"
      : "password"
    : type;

  const vlInputClasses = classNames(styles.vlInput, {
    [styles.errorBorder]: error,
    [styles.focusedBorder]: isFocused,
    [styles.passwordToggle]: showPasswordToggle,
  });

  const labelClasses = classNames(styles.label, {
    [styles.floating]: isFocused || value,
    [styles.error]: error,
  });

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <VLInput
          id={id}
          type={inputType}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder=""
          className={vlInputClasses}
          autoComplete="off"
        />
        <label htmlFor={id} className={labelClasses}>
          {label}
        </label>
        {showPasswordToggle && (
          <button
            type="button"
            className={styles.toggleButton}
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </button>
        )}
      </div>
    </div>
  );
};

export default VLInputWithLabel;
